<template>
  <div>
    <a-modal
      title="给起个标题"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-input v-model="ModalText" placeholder="请输入50个字以内的标题" :max-length="50" />
    </a-modal>
  </div>
</template>
<script>
export default {
    data() {
        return {
            ModalText: '',
            confirmLoading: false,
        };
    },
    props:{
        querystr:String,
        project:String,
        visible:Boolean
    },
    methods: {
        handleOk() {
            this.confirmLoading = true;
            let that = this;
            let params = {
                type:2,
                project:this.project,
                title:this.ModalText,
                querystr:this.querystr,
                urlparams:false,
            }
            that.$store.dispatch({
                type: "logservice/addlogsql",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    this.handleCancel()
                }
                that.confirmLoading = false;
            }).catch(() => {
                that.confirmLoading = false;
            });
        },
        handleCancel() {
            this.ModalText = ""
            this.$emit('onSqlAddClose',false);
        },
    },
};
</script>
